import { useLocation, useNavigate as useRouter } from "react-router-dom";

export const useLogo = () => {
  const pathname = useLocation().pathname;
  const router = useRouter();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    if (pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      router("/");
    }
  };

  const handlePrefetch = () => {
    if (pathname === "/") {
      return;
    }
  };

  return {
    handleClick,
    handlePrefetch,
  };
};
